import styled, { css } from "styled-components"

import TransitionLink from "~/components/atoms/TransitionLink"
import Typography from "~/components/atoms/Typography"
import { SpacingSize, Color, IsPC, IsMobile, LineHeight, TextSize, RadiusSize } from "~/consts/style-mixins"

// min-heightは100vh-PC版headerの高さ-PC版footerの高さ
export const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 92px - 176px);
  background-color: #f7f7f7;
  padding: 48px 0;

  ${IsMobile(css`
    padding: 32px 0;
  `)}
`

export const AutoRedirect = styled.p`
  margin-top: 8px;
  font-size: ${TextSize.S}px;
  line-height: ${LineHeight.S}%;
  color: ${Color.Attention};
  .bold {
    font-weight: bold;
  }
`

export const SecondaryLink = styled(TransitionLink)`
  margin-top: 16px;
  max-width: 300px;
  cursor: pointer;
`

export const Title = styled(Typography)``

export const SubTitle = styled(Typography)`
  color: ${Color.Black};
  text-align: center;
  margin-top: ${SpacingSize.M}px;

  span {
    font-weight: bold;
    color: ${Color.Attention};
  }
`

export const Label = styled.div`
  text-align: center;
`

export const ForPc = styled.span`
  ${IsMobile(css`
    display: none;
  `)}
`

export const AuthRegisterCompleteLongInternshipContainer = styled.div`
  text-align: center;

  .introduction-banner {
    margin-top: 32px;

    img {
      width: 100%;
      user-drag: none;
    }
  }

  .popular-container {
    margin-top: ${SpacingSize._2XL}px;
  }

  .popular-carousel {
    width: 100%;
    margin-top: ${SpacingSize.M}px;
    overflow: hidden;

    .slick-slider {
      overflow: hidden;
      padding-bottom: ${SpacingSize.XL}px;
    }

    // (Card幅(240) + padding(10)) * 3枚表示 =
    .slick-list {
      width: 750px;

      @media screen and (max-width: 500px) {
        width: 500px;
      }
    }

    .slick-dots {
      position: absolute;
      bottom: 0;
    }
  }

  .popular-carousel-item {
    padding: 0 5px;
  }

  .popular-more-button {
    width: 100%;
    max-width: 243px;
    margin: ${SpacingSize.M}px auto 0;
  }

  .terms-container {
    text-align: left;
    background-color: ${Color.White};
    border-radius: ${RadiusSize.Medium}px;
    padding: 24px 16px 56px;
    margin-top: ${SpacingSize._2XL}px;
    ${IsMobile(css`
      padding: 16px 16px 32px;
    `)}
  }

  .terms-container-inner {
    max-width: 481px;
    margin: auto;
  }

  .term-title {
    text-align: center;
  }

  .term-group {
    margin-top: ${SpacingSize.M}px;

    & + .term-group {
      margin-top: ${SpacingSize._2XL}px;
    }
  }

  .term-label {
    color: ${Color.Black};
  }

  .term-list {
    display: flex;
    flex-wrap: wrap;
  }

  .term {
    color: ${Color.Primary};
    font-size: ${TextSize.XS}px;
    font-weight: bold;
    text-align: center;
    background: ${Color.White};
    border: 1px solid ${Color.Primary};
    border-radius: 8px;
    padding: 9px 10px;
    margin: ${SpacingSize.XS}px ${SpacingSize.XS}px 0 0;
    cursor: pointer;
    &:hover {
      color: ${Color.PrimaryDark};
      border: 1px solid ${Color.PrimaryDark};
    }

    ${IsPC(css`
      width: calc(33% - 7px);
      margin: 8px 4px 0 4px;
    `)}
  }
`

export const AuthRegisterCompleteJobHuntingContainer = styled.div`
  margin-top: ${SpacingSize.XL}px;

  .container {
    background-color: ${Color.White};
    border-radius: ${RadiusSize.Medium}px;
    padding: 24px 16px 56px;
    ${IsMobile(css`
      padding: 16px 16px 32px;
    `)}
  }

  .balloon-container {
    margin: 0 auto;
    width: 52px;

    .balloon {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 52px;
      height: 52px;
      color: ${Color.White};
      font-size: ${TextSize.XS}px;
      font-weight: bold;
      background: ${Color.Primary};
      border-radius: 50%;

      &::before {
        content: "";
        position: absolute;
        bottom: -15px;
        left: 50%;
        margin-left: -10px;
        border: 10px solid transparent;
        border-top: 10px solid ${Color.Primary};
        z-index: 0;
      }
    }
  }

  .catch-copy-container {
    text-align: center;
    margin-top: 8px;
  }

  .progress-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;

    ${IsMobile(css`
      margin-top: 16px;
    `)}
  }

  .progress-circle {
    flex-shrink: 0;
    width: 110px;
    height: 110px;

    ${IsMobile(css`
      width: 90px;
      height: 90px;
    `)}
  }

  .progress-message {
    margin-left: 24px;

    ${IsMobile(css`
      display: flex;
      align-items: center;
      margin-left: 16px;
    `)}
  }

  .button-text-container {
    text-align: center;
    margin-top: 8px;

    ${IsMobile(css`
      margin-top: 16px;
      margin-left: -16px;
      margin-right: -16px;
    `)}
  }

  .button-container {
    width: 100%;
    max-width: 280px;
    margin: 8px auto 0;

    ${IsMobile(css`
      max-width: 188px;
    `)}
  }
`
